import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, ArrowLeft } from 'lucide-react';
import QuestionReview from '../../components/admin/QuestionReview';

const AdminReviewPage = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="page-transition">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin/content')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Content Management
        </Button>
        
        <Card className="mb-6">
          <CardHeader className="bg-gradient-to-r from-[#FF6B6B]/5 to-white">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#FF6B6B] rounded-lg">
                <FileText className="w-6 h-6 text-white" />
              </div>
              <div>
                <CardTitle className="text-2xl">Review Submissions</CardTitle>
                <CardDescription>Review and approve pending question submissions</CardDescription>
              </div>
            </div>
          </CardHeader>
        </Card>
        
        <QuestionReview />
      </div>
    </Layout>
  );
};

export default AdminReviewPage;